import { useEffect, useState } from 'react';
import { SortOption, SortDirection } from '../types';
import { PaperIcon, ClockIcon, AaIcon } from '../../../icons';

import { SelectDropdown } from '../../UI';

const SORT_FIELDS = [
  { value: 'date', label: 'Date added', icon: <ClockIcon /> },
  { value: 'name', label: 'Name', icon: <AaIcon /> },
  { value: 'fileSize', label: 'Size', icon: <PaperIcon /> },
];

const SORT_OPTIONS: { [key in typeof SORT_FIELDS[number]['value']]: { value: SortDirection; label: string; sortValue: SortOption }[] } = {
  date:   [
    { value: "desc", label: "Date added", sortValue: 'date-desc' },
    { value: "asc",  label: "Date added", sortValue: 'date-asc' },
  ],
  name:   [
    { value: "asc",  label: "Name", sortValue: 'name-asc' },
    { value: "desc", label: "Name", sortValue: 'name-desc' },
  ],
  fileSize:   [
    { value: "asc",  label: "Size", sortValue: 'file-size-asc' },
    { value: "desc", label: "Size", sortValue: 'file-size-desc' },
  ],
}


export interface SortDropdownProps {
  /** Current sort option */
  sortBy: SortOption;
  /** Callback for sort option changes */
  onSortChange: (sortBy: SortOption) => void;
}

export const SortDropdown: React.FC<SortDropdownProps> = ({ sortBy, onSortChange }) => {
  const [sortField, setSortField] = useState<keyof typeof SORT_OPTIONS>('date');
  const [sortOrder, setSortOrder] = useState<SortDirection>('desc');

  useEffect(() => {
    for (const [field, options] of Object.entries(SORT_OPTIONS) as [keyof typeof SORT_OPTIONS, typeof SORT_OPTIONS[keyof typeof SORT_OPTIONS]][]) {
      const match = options.find(option => option.sortValue === sortBy);
      if (match) {
        setSortField(field);
        setSortOrder(match.value);
        break;
      }
    }
  }, []);

  const handleSortChange = (selectedSortField: keyof typeof SORT_OPTIONS, selectedSortOrder: SortDirection) => {
    setSortField(selectedSortField);
    setSortOrder(selectedSortOrder);

    const selectedOption = SORT_OPTIONS[selectedSortField].find(option => option.value === selectedSortOrder);
    if (selectedOption) {
      onSortChange(selectedOption.sortValue);
    }
  };

  return (
    <SelectDropdown
      placeholder="Sort by"
      options={SORT_FIELDS.map(field => ({ value: field.value, label: field.label, icon: field.icon }))}
      value={sortField}
      onChange={(value) => handleSortChange(value as keyof typeof SORT_OPTIONS, sortOrder)}
      title="Sort by"
      className='small'
    >
      <>
        <hr />
        <div className='pl16 pb8'>
          <fieldset>
            <div className="field pt8 pb8">
              <label><input type="radio" name="sortOrder" value="asc" checked={sortOrder === 'asc'} onChange={() => handleSortChange(sortField, 'asc')} onClick={e => e.stopPropagation()} /> Ascending</label>
            </div>
            <div className="field pt8 pb8">
              <label><input type="radio" name="sortOrder" value="desc" checked={sortOrder === 'desc'} onChange={() => handleSortChange(sortField, 'desc')} onClick={e => e.stopPropagation()} /> Descending</label>
            </div>
          </fieldset>
        </div>
      </>
    </SelectDropdown>
  )
}